import { render, staticRenderFns } from "./ApplianceInfo.vue?vue&type=template&id=f6661a96"
import script from "./ApplianceInfo.vue?vue&type=script&lang=js"
export * from "./ApplianceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports